import React from "react";
import clsx from "clsx";

const Example = ({ children, className, ...props }) => {
  return (
    <div
      className={clsx(
        "relative p-2 border-l-4 rounded-xl border-sc-try-border-color before:content-['try'] before:block lg:before:absolute before:uppercase before:font-bold before:italic before:tracking-widest before:text-md before:text-sc-try-color lg:border-none lg:p-0 lg:before:content-['try'] lg:before:right-0 lg:before:mr-[104%] lg:before:mt-0 lg:after:content-[attr(data-after)] lg:after:w-4 lg:after:absolute lg:after:border-l-4 lg:after:h-full lg:after:left-0 lg:after:top-0 lg:after:-ml-4 lg:after:rounded-xl lg:after:border-sc-try-border-color",
        className
      )}
    >
      {children}
    </div>
  );
};

export default Example;
